module.exports = ".LoginHeader{text-align:center;margin-top:2rem}.LoginHeader_logo{margin:0 auto 2rem;max-width:200px}.LoginHeader_logo svg{max-width:100%}\n"